module.exports = __webpack_public_path__ + "static/16-df47f16252e5ed55217ebe24b419a312.jpg";